export default function getValueType({isPhone, isMonetary, isPercentage, isRichText, attr = {}}) {
    if (isPhone) return 'TelType';

    if (isMonetary) return 'money';

    if (isPercentage) return 'percent';

    if (isRichText || attr['rich-text-editor']) return 'html';

    return null;
}
